/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpsb_responsive_pulse_bet_blocks"];
/******/ 	window["webpackJsonpsb_responsive_pulse_bet_blocks"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(64));
__export(__webpack_require__(66));
__export(__webpack_require__(6));
__export(__webpack_require__(105));
__export(__webpack_require__(107));
__export(__webpack_require__(109));
__export(__webpack_require__(111));
__export(__webpack_require__(10));
__export(__webpack_require__(113));
__export(__webpack_require__(115));
__export(__webpack_require__(17));
__export(__webpack_require__(16));
__export(__webpack_require__(15));
__export(__webpack_require__(117));
__export(__webpack_require__(119));
__export(__webpack_require__(121));
__export(__webpack_require__(123));


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(43));
__export(__webpack_require__(45));
__export(__webpack_require__(11));
__export(__webpack_require__(48));
__export(__webpack_require__(60));
__export(__webpack_require__(62));
__export(__webpack_require__(125));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(68));
__export(__webpack_require__(88));
__export(__webpack_require__(90));
__export(__webpack_require__(92));
__export(__webpack_require__(95));
__export(__webpack_require__(97));
__export(__webpack_require__(99));
__export(__webpack_require__(101));
__export(__webpack_require__(103));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(70));
__export(__webpack_require__(13));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(73));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(77));
__export(__webpack_require__(82));
__export(__webpack_require__(84));
__export(__webpack_require__(19));
__export(__webpack_require__(18));
__export(__webpack_require__(20));
__export(__webpack_require__(22));
__export(__webpack_require__(86));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(94));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(47));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(51));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(72));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Models = __webpack_require__(3);
var sb_resp_lib_1 = __webpack_require__(2);
var index_1 = __webpack_require__(15);
var models_1 = __webpack_require__(3);
sb_resp_lib_1.initPolyfills();
var Parser = /** @class */ (function () {
    function Parser() {
    }
    /**
     *
     * @param initArray array with values to create QAEventInfo
     */
    Parser.QAEventInfoParser = function (initArray) {
        var lines = new Array();
        if (Array.isArray(initArray[2])) {
            try {
                for (var _a = __values(initArray[2]), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var value = _b.value;
                    var currLine = this.QaLineParse(value);
                    lines.push(currLine);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return new models_1.QAEventInfoExt({
            id: parseInt(initArray[0]),
            typeId: parseInt(initArray[1]),
            lines: lines,
            name: initArray[3],
            typeName: initArray[5],
            branchId: parseInt(initArray[13]),
            leagueId: initArray[14],
            leagueName: initArray[15],
            date: new Date(initArray[16]),
            link: initArray[17],
        });
        var e_1, _c;
    };
    /**
     *
     * @param initData JS object
     * @param purchase  Open Bet Purchase
     */
    Parser.SPBetParser = function (initData) {
        return new Models.SPOpenBet({
            betId: initData.BetID,
            generatedId: initData.GeneratedID,
            statusId: initData.StatusID,
            currentBalance: initData.Gain,
            deadHeatDeposit: initData.DeadHeatDeposit,
            commission: initData.Commission,
            profitLoss: initData.ProfitLoss,
            percentDeduction: initData.PercentDeduction,
            mapping: initData.Mappings,
            clientOdds: initData.OddsFrCl,
            numberOfBets: initData.NumOfBets,
            betSubType: initData.BSubType,
            betTypeId: initData.BType,
            comboSize: initData.ComboSize,
            betName: initData.BName,
            deposit: initData.Stake,
            gain: initData.Gain,
            odds: initData.Odds,
        });
    };
    /**
     *
     * @param initData  SPSelection object data
     */
    Parser.SPSelectionParser = function (initData) {
        return new Models.SPSelection({
            selectionId: initData.SelectionID,
            statusId: initData.StatusID,
            odds: initData.Odds,
            points: initData.Points,
            result: initData.Result,
            id: initData.ID,
            lineId: initData.LineID,
            lineGroupId: initData.LineGroupID,
            rowTypeId: initData.RowTypeID,
            isOption: initData.IsOption,
            isRegular: initData.IsRegular,
            eventId: initData.EventID,
            orgOdds: initData.OrgOdds,
            clientOdds: initData.ClientOdds,
            branchId: initData.BranchID,
            leagueId: initData.LeagueID,
            masterLeagueId: initData.MasterLeagueID,
            splitTypeId: initData.SplitTypeID,
            eventTypeId: initData.EventTypeID,
            eventGroupId: initData.EventGroupID,
            isLive: initData.IsLive,
            qPar1: initData.QPar1,
            qPar2: initData.QPar2,
            orderId: initData.OrderID,
            branchName: initData.BranchName,
            leagueName: initData.LeagueName,
            eventName: initData.EventName,
            eventTypeName: initData.EventTypeName,
            eventDate: new Date(initData.EventDate),
        });
    };
    /**
     *
     * @param initData SPSelection data
     */
    Parser.SPPurchaseParser = function (initData) {
        var jsonData = JSON.parse(initData.JSONProperties);
        return new Models.SPPurchase({
            purchaseId: initData.PurchaseID,
            purchaseDate: new Date(initData.PurchaseDate),
            purchaseStatus: initData.PurchaseStatus,
            customerId: initData.CustomerID,
            currencyCode: initData.CurrencyCode,
            currentBalance: initData.CurrentBalance,
            oddsStyleId: initData.OddsStyleID,
            totalGain: initData.TotalGain,
            totalStake: initData.TotalStake,
            selections: initData.Selections.map(function (selection) {
                return Parser.SPSelectionParser.call(Parser, __assign({}, jsonData.Selections.find(function (sel) { return sel.ID === selection.SelectionID; }), selection));
            }),
            bets: initData.Bets.map(function (bet) {
                return Parser.SPBetParser.call(Parser, __assign({}, bet, jsonData.Bets[0]));
            })
        });
    };
    /**
    *
    * @param initArray array with values to create QAEventInfo
    */
    Parser.QaLineParse = function (initArray) {
        return new sb_resp_lib_1.QALineInfo({
            id: parseInt(initArray[0]),
            odds: parseInt(initArray[1]),
            lineName: initArray[2],
            lineTypeId: parseInt(initArray[3]),
            fractOddsDividend: parseInt(initArray[5]),
            fractOddsDivisor: parseInt(initArray[6]),
            lineStateId: parseInt(initArray[7]),
            lineTypeName: initArray[8],
            qaParameter2: parseInt(initArray[9]),
            qaParameter1: parseInt(initArray[10]),
            feedSelectionId: parseInt(initArray[13])
        });
    };
    Parser.QALiveSlipSelectionParser = function (event, jsonData) {
        var slipSelection = new index_1.QALiveSlipSelection({
            masterEventId: event.masterEventId,
            lineId: jsonData.LineID,
            eventId: event.id,
            type: event.typeId,
            leagueId: jsonData.LeagueID,
            branchId: jsonData.BranchID,
            branchName: jsonData.BranchName,
            leagueName: jsonData.LeagueName,
            eventTypeId: event.typeId,
            eventTypeName: jsonData.EventTypeName,
            oppositeEventTypeId: jsonData.OppositeEventTypeID,
            team1Name: jsonData.Team1Name,
            team2Name: jsonData.Team2Name,
            liveGroupId: jsonData.LiveGroupID,
            preLiveGroupId: jsonData.PreliveGroupID,
            maxBet: jsonData.maxBet,
            minBet: jsonData.minBet,
            waitingAllowed: jsonData.waitingAllowed,
            singleSelectionRisk: jsonData.SingleSelectionRisk,
            lineTypeName: jsonData.LineTypeName,
            odds: jsonData.Odds,
            eventDate: event.date,
            lineTypeId: jsonData.LineTypeID,
            betTypeId: 7,
            useEventName: jsonData.useEventName,
            eventName: jsonData.EventName,
            lineName: jsonData.LineName,
            asianLineName: jsonData.AsianLineName,
            mappedLineTypeId: jsonData.MappedLineTypeID,
            swapped: jsonData.Swapped,
            splitTypeId: jsonData.SplitTypeID,
            SISEventId: jsonData.SISEventID,
            GBSEventId: jsonData.GBSEventID,
            feedEventId: jsonData.FeedEventID,
            feedProviderId: jsonData.FeedProviderID,
            isEachWayEnabled: jsonData.isEachWayEnabled,
            relatedToId: jsonData.RelatedToID,
            danger: jsonData.Danger,
            qaParameter1: jsonData.QAParameter1,
            qaParameter2: jsonData.QAParameter2
        });
        if (jsonData.ScoreChanged) {
            slipSelection.score1 = jsonData.ScoreChanged[0];
            slipSelection.score2 = jsonData.ScoreChanged[1];
        }
        return slipSelection;
    };
    Parser.masterEventIncidentParser = function (initArray) {
        return new Models.MasterEventIncident({
            incidentID: parseInt(initArray[0]),
            masterEventID: parseInt(initArray[1]),
            incitentTimeMs: parseInt(initArray[2]),
            incidentTypeID: parseInt(initArray[3]),
            incidentStatusID: parseInt(initArray[4]),
        });
    };
    return Parser;
}());
exports.Parser = Parser;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(74));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(75));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(76));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(78));


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(79));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(80));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BetPlacementStatus;
(function (BetPlacementStatus) {
    BetPlacementStatus[BetPlacementStatus["NotStarted"] = 0] = "NotStarted";
    BetPlacementStatus[BetPlacementStatus["InProcess"] = 1] = "InProcess";
    BetPlacementStatus[BetPlacementStatus["Error"] = 2] = "Error";
    BetPlacementStatus[BetPlacementStatus["Success"] = 3] = "Success";
})(BetPlacementStatus = exports.BetPlacementStatus || (exports.BetPlacementStatus = {}));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(81));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(7));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _DebounceJs = __webpack_require__(87);

var _DebounceJs2 = _interopRequireDefault(_DebounceJs);

exports['default'] = _DebounceJs2['default'];

_defaults(exports, _interopExportWildcard(_DebounceJs, _defaults));

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(44));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var baseClass = "rj-slim-progressbar";
var SlimProgressbar = /** @class */ (function (_super) {
    __extends(SlimProgressbar, _super);
    function SlimProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlimProgressbar.prototype.render = function () {
        return (React.createElement("div", { id: "pipe-" + this.props.eventID, className: baseClass },
            React.createElement("div", { className: baseClass + "__separator" }),
            React.createElement("div", { className: baseClass + "__pipe" }, this.props.children)));
    };
    return SlimProgressbar;
}(React.Component));
exports.SlimProgressbar = SlimProgressbar;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var TimedChangbleFrame = /** @class */ (function (_super) {
    __extends(TimedChangbleFrame, _super);
    function TimedChangbleFrame(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { currentChildIndex: 0 };
        return _this;
    }
    TimedChangbleFrame.prototype.componentDidMount = function () {
        this.setNextFrame(this.state.currentChildIndex);
    };
    TimedChangbleFrame.prototype.setNextFrame = function (index) {
        var _this = this;
        /* istanbul ignore next */
        if (index === this.props.childrenData.length) {
            /* istanbul ignore next */
            return;
        }
        else {
            setTimeout(function () {
                var handler = _this.props.childrenData[index].timedOutHandler;
                handler && handler();
                _this.setNextFrame(index + 1);
            }, this.props.childrenData[index].timeOutMili);
            this.setState({ currentChildIndex: index });
        }
    };
    TimedChangbleFrame.prototype.render = function () {
        return (this.props.children && this.props.children[this.state.currentChildIndex]);
    };
    return TimedChangbleFrame;
}(React.Component));
exports.TimedChangbleFrame = TimedChangbleFrame;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PulseBetButton = /** @class */ (function (_super) {
    __extends(PulseBetButton, _super);
    function PulseBetButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PulseBetButton.prototype.render = function () {
        var cls = this.props.modifier ? " rj-my-pulse-bets__pulse-btn--" + this.props.modifier : "";
        return (React.createElement("button", { type: "button", className: "rj-my-pulse-bets__pulse-btn" + cls, onClick: this.props.handler, disabled: this.props.isDisabled }, this.props.children));
    };
    return PulseBetButton;
}(React.Component));
exports.PulseBetButton = PulseBetButton;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(49));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:cyclomatic-complexity */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var helpers_1 = __webpack_require__(50);
var defaultStartingWidth = 46; // related to the CSS, please be carefull
/* istanbul ignore next */
function trackProgress(duration, callback, animation, elements, complete, remaining, start, tweenValue) {
    this.iterator = this.totalTime - (this.totalProgress + (duration * complete));
    var d = 1 - Math.ceil((this.iterator / this.totalTime) * 100) / 100;
    var tmp = helpers_1.processColorDiff(this.colors, d);
    var time = helpers_1.parseTime(this.iterator);
    this.point && (this.point.innerText = time,
        this.point.style.background = "" + helpers_1.returnColor(tmp));
    this.trackBg && (this.trackBg.style.background = "linear-gradient(to right, " + helpers_1.returnColor(this.colors.start) + ", " + helpers_1.returnColor(tmp) + ")");
    if (typeof callback === "function") {
        callback(animation.value, d, time);
    }
}
/* istanbul ignore next */
function animation(segments, t, v1, v2) {
    var t1, animations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                t1 = t;
                animations = segments.periods.map(function (x, i, a) {
                    var d = 0;
                    if (v2[i] === 0) {
                        t1 -= x.duration;
                    }
                    if (v1 > v2[i] && v2[i] > 0) {
                        d = x.duration - t1;
                    }
                    if (v1 === v2[i]) {
                        d = x.duration;
                    }
                    return __assign({}, x, { duration: d, startTime: x.startTime });
                });
                return [4 /*yield*/, __assign({}, animations[0], { width: "33.4%" })];
            case 1:
                _a.sent();
                return [4 /*yield*/, __assign({}, animations[1], { width: "66.7%" })];
            case 2:
                _a.sent();
                return [4 /*yield*/, __assign({}, animations[2], { width: "100%" })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var Track = /** @class */ (function (_super) {
    __extends(Track, _super);
    /* istanbul ignore next */
    function Track(props) {
        var _this = _super.call(this, props) || this;
        _this.colors = _this.props.colors;
        _this.endTime = helpers_1.splitTime(_this.props.segments.endTime);
        _this.startTime = helpers_1.splitTime(_this.props.segments.startTime);
        // this.totalTime = ((this.endTime[0] * 60 + this.endTime[1]) * 1000) - ((this.startTime[0] * 60 + this.startTime[1]) * 1000)
        _this.totalTime = _this.props.segments.periods.reduce(function (a, b) { return a += b.duration; }, 0) * 1000;
        _this.totalProgress = _this.props.segments.expiredBetProgressInMilliseconds;
        _this.iterator = _this.totalTime - _this.totalProgress;
        _this.state = {
            anim: {},
            startingWidth: defaultStartingWidth + "px",
            start: typeof _this.props.start === "undefined" ? true : _this.props.start
        };
        return _this;
    }
    /* istanbul ignore next */
    Track.prototype.shouldAnimate = function () {
        if (this.state.start && this.getAnimation) {
            this.startAnimation(this.getAnimation.next());
        }
    };
    /* istanbul ignore next */
    Track.prototype.componentDidMount = function () {
        var _this = this;
        var v = this.track && this.track.offsetWidth;
        if (v) {
            var v1_1 = v / 3;
            var t = this.props.segments.expiredBetProgressInMilliseconds / 1000;
            var t1_1 = t;
            var v2 = this.props.segments.periods.map(function (x) {
                var o = v1_1;
                if (t1_1 > 0) {
                    o = t1_1 >= x.duration ? 0 : (v1_1 / x.duration) * (x.duration - t1_1);
                }
                t1_1 -= x.duration;
                return o;
            });
            this.getAnimation = animation(this.props.segments, t, v1_1, v2);
            v2.filter(function (x) { return x === 0; }).forEach(function () { return _this.getAnimation.next(); });
            var d = v - v2.reduce(function (x, y) { return x += y; }, 0);
            var s = d + defaultStartingWidth;
            var startingWidth = s < v1_1 ? s : d;
            this.setState({ startingWidth: startingWidth / v * 100 + "%" });
        }
        this.shouldAnimate();
    };
    /* istanbul ignore next */
    Track.prototype.callCallback = function (cb, params) { typeof cb === "function" && cb.apply(void 0, __spread(params)); };
    /*istanbul ignore next */
    Track.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.state.start !== nextProps.start) {
            this.setState({ start: nextProps.start }, function () {
                _this.shouldAnimate();
            });
        }
    };
    /* istanbul ignore next */
    Track.prototype.startAnimation = function (animation) {
        var _this = this;
        if (!animation.done) {
            var duration_1 = animation.value.duration * 1000;
            this.setState({
                anim: {
                    animation: { width: animation.value.width },
                    easing: "linear",
                    duration: duration_1,
                    begin: function () {
                        if (_this.props.callbacks && _this.props.callbacks.begin) {
                            _this.callCallback(_this.props.callbacks.begin, [animation.value]);
                        }
                    },
                    progress: function (elements, complete, remaining, start, tweenValue) {
                        var cb;
                        if (_this.props.callbacks && _this.props.callbacks.progress) {
                            cb = _this.props.callbacks.progress;
                        }
                        trackProgress.call(_this, duration_1, cb, animation, elements, complete, remaining, start, tweenValue);
                    },
                    complete: function () {
                        _this.totalProgress += duration_1;
                        _this.startAnimation(_this.getAnimation.next());
                        if (_this.props.callbacks && _this.props.callbacks.complete) {
                            _this.callCallback(_this.props.callbacks.complete, [animation.value]);
                        }
                    }
                },
            });
        }
    };
    /* istanbul ignore next */
    Track.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-pulse-bet__track", ref: function (n) { return _this.track = n; } },
            React.createElement(sb_resp_lib_1.Animate, __assign({}, this.state.anim, { runOnMount: true, loop: false, reverse: false }),
                React.createElement("div", { className: "rj-pulse-bet__track-wrap", style: { width: "" + this.state.startingWidth } },
                    React.createElement("div", { className: "rj-pulse-bet__track-bg", ref: function (n) { return _this.trackBg = n; } }),
                    React.createElement("div", { className: "rj-pulse-bet__track-point", ref: function (n) { return _this.point = n; } }, helpers_1.parseTime(this.iterator))))));
    };
    return Track;
}(React.Component));
exports.Track = Track;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(12));
__export(__webpack_require__(52));
__export(__webpack_require__(54));
__export(__webpack_require__(56));
__export(__webpack_require__(58));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cache = {};
/**
 * padString pads string with N number of characters in front of the supplied value
 * @param padding
 * @param char
 * @param value
 * @return {string} Padded string
 */
function padString(length, char, value) {
    var k = length.toString() + char + value;
    if (!cache[k]) {
        var s = value || "";
        while (s.length < length) {
            s = char + s;
        }
        cache[k] = s;
    }
    return cache[k];
}
exports.padString = padString;
exports.padTime = padString.bind(undefined, 2, "0");


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(53));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * splitTime splits a string presented time like XX:XX into array of Numbers
 * @param s {String} expects string of the type XX:XX
 * @returns number[]
 */
exports.splitTime = function (s) { return s.split(":").map(function (x) { return parseInt(x); }); };


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(55));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PadString_1 = __webpack_require__(12);
var cache = {};
function parseTime(ms) {
    var toSeconds = Math.ceil(Math.abs(ms) / 1000);
    if (!cache[toSeconds]) {
        var sec = toSeconds % 60;
        var min = Math.ceil((toSeconds - sec) / 60);
        cache[toSeconds] = (min > 0 || sec > 10) ? PadString_1.padTime(min.toString()) + ":" + PadString_1.padTime(sec.toString()) : sec.toString();
    }
    return cache[toSeconds];
}
exports.parseTime = parseTime;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(57));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * returnColor converts color object into string that can be used with different CSS properties like background. Intended to work with RGBA color objects
 * @param c {Object} contains properties with numbers representing a RGBA color
 * @returns color {String} string representation of the colors as used by the CSS background property
 */
exports.returnColor = function (c) { return "rgba(" + (c.r || 0) + ", " + (c.g || 0) + ", " + (c.b || 0) + ", " + (c.a || 1) + ")"; };


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(59));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cache = {};
/**
 * processColorDiff parses start and end colors returning a new color object that contains the delta between the input colors
 * @param colors Object representing start and end of gradient colors in the RGBA format
 * @param progress Float number presenting the percentage of completion of the color transformation
 * @returns {Object} Reduced color in RGBA format
 */
exports.processColorDiff = function (colors, progress) {
    return Object.keys(colors.start).reduce(function (x, y) {
        var k = y + colors.start[y].toString() + colors.end[y].toString() + progress.toFixed(2);
        if (!cache[k]) {
            var v = (colors.start[y] + ((colors.end[y] - colors.start[y]) * progress));
            cache[k] = y !== "a" ? Math.round(v) : v;
        }
        x[y] = cache[k];
        return x;
    }, { r: 0, g: 0, b: 0, a: 0 });
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(61));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var Heading = /** @class */ (function (_super) {
    __extends(Heading, _super);
    function Heading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Heading.prototype.render = function () {
        return (React.createElement(sb_resp_lib_1.HeadingTypeTwo, { modifier: "my-pulse-bets" },
            React.createElement("span", { className: "rj-heading-2__left-container" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-24 i-o-pulsebet-pulse" })),
            React.createElement("span", { className: "rj-heading-2__text-container" },
                React.createElement("span", { className: "rj-heading-2__text" }, this.props.label))));
    };
    return Heading;
}(React.Component));
exports.Heading = Heading;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(63));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sb_resp_lib_1 = __webpack_require__(2);
var models_1 = __webpack_require__(3);
var mobx_react_1 = __webpack_require__(4);
var baseClass = "rj-winnings";
var Winnings = /** @class */ (function (_super) {
    __extends(Winnings, _super);
    function Winnings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Winnings.prototype.renderCurrent = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + models_1.PriceStatusClass.periodCurrent) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-16 i-o-sport-" + this.props.inputData.branchID }),
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderWithoutClass = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-16 i-o-sport-" + this.props.inputData.branchID }),
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderResulting = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + models_1.PriceStatusClass.periodResulting) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-16 i-o-sport-" + this.props.inputData.branchID }),
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderPreperiod = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + models_1.PriceStatusClass.periodPre) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-16 i-o-sport-" + this.props.inputData.branchID }),
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderPeriodOver = function (data) {
        var fadingClass = this.props.onStakeChangeFading ? " " + baseClass + "__item--fading-winnings" : "";
        return (React.createElement("div", { key: baseClass + "-" + data.periodNumber, className: baseClass + "__item" + (" " + baseClass + "__item--" + models_1.PriceStatusClass.periodOver) + fadingClass, "data-atr": data.status },
            React.createElement("div", { className: baseClass + "__item-inner" },
                React.createElement(sb_resp_lib_1.Icon, { i: "i-16 i-o-sport-" + this.props.inputData.branchID }),
                React.createElement("span", { className: baseClass + "__sum" }, data.winningValue))));
    };
    Winnings.prototype.renderWinning = function (status) {
        switch (status.winningStatus) {
            case 0:
                return this.renderPreperiod(status);
            case 1:
                return this.renderCurrent(status);
            case 2:
                return this.renderResulting(status);
            case 3:
                return this.renderPeriodOver(status);
        }
        return this.renderWithoutClass(status);
    };
    Winnings.prototype.render = function () {
        return (React.createElement("div", { className: baseClass + "__items-holder" }, this.props.inputData.winnings.map(this.renderWinning, this)));
    };
    Winnings = __decorate([
        mobx_react_1.observer
    ], Winnings);
    return Winnings;
}(React.Component));
exports.Winnings = Winnings;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(65));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
* StakeInputData type that defines the input data of the stake actions
*
* @typedef StakeInputData
* @type {type}
* @property {stakeValue} StakeValue current stake including the currency sign
* @property {isMinusActive} IsMinusActive if the minus icon is clickable
* @property {isPlusActive} IsPlusActive if the plus icon is clickable
* @property {stakeUp} StakeUp handler function which rises the stake
* @property {stakeDown} StakeDown handler function which lowers the stake
*/
Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(67));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StakeModifier;
(function (StakeModifier) {
    StakeModifier["plus"] = "plus";
    StakeModifier["minus"] = "minus";
})(StakeModifier = exports.StakeModifier || (exports.StakeModifier = {}));
var PriceStatusClass;
(function (PriceStatusClass) {
    PriceStatusClass["periodOver"] = "over";
    PriceStatusClass["periodResulting"] = "resulting";
    PriceStatusClass["periodCurrent"] = "current";
    PriceStatusClass["periodPre"] = "not-started";
})(PriceStatusClass = exports.PriceStatusClass || (exports.PriceStatusClass = {}));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(69));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var view_1 = __webpack_require__(7);
var BasicPulseBetViewModel = /** @class */ (function () {
    function BasicPulseBetViewModel(stake, pulseBetMetadata, gameProgressInMilli) {
        this.viewHelperDependency = view_1.ViewHelper.getInstance();
        this.calculatedPeriodHelperDependency = view_1.CalculatedPeriodHelper.getInstance();
        this.stake = stake;
        this.pulseBetMetadata = pulseBetMetadata;
    }
    BasicPulseBetViewModel.prototype.setViewHelperDependency = function (viewHelper) {
        this.viewHelperDependency = viewHelper;
    };
    BasicPulseBetViewModel.prototype.setCalculatedPeriodHelperDependency = function (calculatedPeriodHelper) {
        this.calculatedPeriodHelperDependency = calculatedPeriodHelper;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], BasicPulseBetViewModel.prototype, "stake", void 0);
    return BasicPulseBetViewModel;
}());
exports.BasicPulseBetViewModel = BasicPulseBetViewModel;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(71));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ViewModel = __webpack_require__(6);
var ViewHelper_1 = __webpack_require__(13);
var CalculatedPeriodHelper = /** @class */ (function () {
    function CalculatedPeriodHelper() {
        this.viewHelperDependency = ViewHelper_1.ViewHelper.getInstance();
    }
    CalculatedPeriodHelper.getInstance = function () {
        if (!this.instance) {
            this.instance = new CalculatedPeriodHelper();
        }
        return this.instance;
    };
    CalculatedPeriodHelper.prototype.setCurrentUserInfo = function (currentUserInfo) {
        this.currentUserInfo = currentUserInfo;
    };
    CalculatedPeriodHelper.prototype.setViewHelperDependency = function (viewHelper) {
        this.viewHelperDependency = viewHelper;
    };
    CalculatedPeriodHelper.prototype.wrappedCalculatedPeriodsStateless = function (stake, pulseBetMetadata) {
        var numberOfPeriods = pulseBetMetadata.periods.length;
        var percentOfEachPeriod = 100 / numberOfPeriods;
        var result = [];
        for (var index = 0; index < pulseBetMetadata.periods.length; index++) {
            var calculatedPeriod = this.transformPeriodToCalculatedPeriodStateless(pulseBetMetadata.periods[index], index, stake, pulseBetMetadata, percentOfEachPeriod);
            calculatedPeriod.absolutePercentFromTotal = calculatedPeriod.relativePercentFromTotal + (index > 0 ? result[index - 1].absolutePercentFromTotal : 0);
            result.push(calculatedPeriod);
        }
        ;
        return result;
    };
    CalculatedPeriodHelper.prototype.formatWinnings = function (winnings) {
        var formattedWinnings = "" + winnings;
        if (this.currentUserInfo) {
            formattedWinnings = this.currentUserInfo.toUserFormatedCurrencyString(winnings);
        }
        formattedWinnings = formattedWinnings.replace(/\s+/g, ""); //remove all space
        formattedWinnings = formattedWinnings.replace(/\.0+/g, ""); //remove all trailing zeros
        return formattedWinnings;
    };
    CalculatedPeriodHelper.prototype.transformPeriodToCalculatedPeriodStateless = function (p, index, stake, pulseBetMetadata, percentOfEachPeriod) {
        var calculatedWin = Math.floor(+(stake * p.europeanOdds * 100).toPrecision(12)) / 100;
        var calculated = new ViewModel.CalculatedPeriod({
            index: index,
            isLast: index + 1 === pulseBetMetadata.periods.length,
            period: p,
            calculatedWin: calculatedWin,
            formatedWin: this.formatWinnings(calculatedWin),
            periodDurationInMilli: p.endTimeInMilli - p.startTimeInMilli,
            relativePercentFromTotal: percentOfEachPeriod,
            absolutePercentFromTotal: percentOfEachPeriod * (index + 1),
            invertedStartTimeInMinutesFormat: this.viewHelperDependency.milliToMinutesString(pulseBetMetadata.durationInMilli - p.startTimeInMilli),
            relativeRangeFormatted: this.viewHelperDependency.milliRangeToMinutesRange(p.startTimeInMilli, p.endTimeInMilli, pulseBetMetadata.typeId),
            absoluteToGameFormattedGameStart: "",
            absoluteGameFormattedGameEnd: "",
            absoluteToGameStartInMilli: 0,
            absoluteToGameEndInMilli: 0,
        });
        return calculated;
    };
    CalculatedPeriodHelper.prototype.wrappedCalculatedPeriods = function (stake, pulseBetMetadata) {
        var result = this.wrappedCalculatedPeriodsStateless(stake, pulseBetMetadata);
        try {
            for (var result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                var period = result_1_1.value;
                period.absoluteToGameStartInMilli = period.period.startTimeInMilli;
                period.absoluteToGameEndInMilli = period.period.endTimeInMilli;
                period.absoluteToGameFormattedGameStart = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameStartInMilli);
                period.absoluteGameFormattedGameEnd = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameEndInMilli);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (result_1_1 && !result_1_1.done && (_a = result_1.return)) _a.call(result_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        ;
        return result;
        var e_1, _a;
    };
    return CalculatedPeriodHelper;
}());
exports.CalculatedPeriodHelper = CalculatedPeriodHelper;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __webpack_require__(8);
var ViewHelper = /** @class */ (function () {
    function ViewHelper() {
    }
    ViewHelper.getInstance = function () {
        if (!this.instance) {
            this.instance = new ViewHelper();
        }
        return this.instance;
    };
    ViewHelper.prototype.milliToMinutesString = function (totalMilli, cutZeroMinutes, eventTypeId) {
        var totalSecondsRounded = Math.round(totalMilli / 1000);
        if (totalSecondsRounded < 61 && cutZeroMinutes) {
            return eventTypeId === store_1.PulseBetsTypes.OneMinPulse || eventTypeId === store_1.PulseBetsTypes.ThirtySecPulse ?
                "" + totalSecondsRounded :
                this.numToStringWithZeroPadd(totalSecondsRounded);
        }
        else {
            var minutesPart = Math.floor(totalSecondsRounded / 60);
            var secondsPart = totalSecondsRounded % 60;
            return this.numToStringWithZeroPadd(minutesPart) + ":" + this.numToStringWithZeroPadd(secondsPart);
        }
    };
    ViewHelper.prototype.milliRangeToMinutesRange = function (milli1, milli2, eventTypeId) {
        var smallerThanMin = (milli1 < 61000 && milli2 < 61000);
        return this.milliToMinutesString(milli1, smallerThanMin, eventTypeId) + "-" + this.milliToMinutesString(milli2, smallerThanMin, eventTypeId);
    };
    ViewHelper.prototype.numToStringWithZeroPadd = function (num) {
        return (num < 10) ? "0" + num : "" + num;
    };
    return ViewHelper;
}());
exports.ViewHelper = ViewHelper;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var sb_resp_lib_1 = __webpack_require__(2);
var Parser_1 = __webpack_require__(14);
var models_1 = __webpack_require__(3);
var data_1 = __webpack_require__(9); //TO DO  STORE should not use local block objects
var debounce_decorator_1 = __webpack_require__(24);
var PulseBetsTypes;
(function (PulseBetsTypes) {
    PulseBetsTypes[PulseBetsTypes["ThirtySecPulse"] = 1441] = "ThirtySecPulse";
    PulseBetsTypes[PulseBetsTypes["OneMinPulse"] = 1442] = "OneMinPulse";
    PulseBetsTypes[PulseBetsTypes["FiveMinPulse"] = 1443] = "FiveMinPulse";
    PulseBetsTypes[PulseBetsTypes["TenMinPulse"] = 1444] = "TenMinPulse";
})(PulseBetsTypes = exports.PulseBetsTypes || (exports.PulseBetsTypes = {}));
var PulseBettingStore = /** @class */ (function () {
    function PulseBettingStore() {
        this.name = "PulseBettingStore";
        this.masterEventId = 0;
        this.eventsToUpdate = [];
        this.events = [];
        this.successfullUpdateEventsCallback = this.successfullUpdateEventsCallback.bind(this);
        this.pulsebetsDataForComponents = [];
        this.branchId = 1;
        this.eventIds = [];
        this.isUserLogged = false;
        this.awaitingCallback = [];
        this.eventsManager = new EventsManager();
    }
    PulseBettingStore.prototype.clear = function () {
        this.eventIds = [];
        this.events = [];
        clearTimeout(this.updateEventsTimeout);
        this.pulsebetsDataForComponents = [];
        this.eventsManager.removeEventListener("onPulseBetWaitingResponse", this, true);
    };
    PulseBettingStore.prototype.setFacade = function (facade) {
        if (typeof this.facade === "undefined" && facade) {
            this.facade = facade;
            this.facade.addSubscriber(this.subscribeToPush, this.name, sb_resp_lib_1.PushMessageTypes.Odds, {
                SubscriberEvents: this.eventsToUpdate, IsBetSlip: false
            });
        }
    };
    PulseBettingStore.prototype.setEvents = function (eventIds) {
        this.eventIds = eventIds;
        try {
            for (var eventIds_1 = __values(eventIds), eventIds_1_1 = eventIds_1.next(); !eventIds_1_1.done; eventIds_1_1 = eventIds_1.next()) {
                var ev = eventIds_1_1.value;
                this.eventsToUpdate[ev.id] = {
                    ID: ev.id,
                    updateString: ev.id.toString(),
                    /* istanbul ignore next */
                    getUpdateString: function () {
                        /* istanbul ignore next */
                        return this.updateString;
                    }
                };
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (eventIds_1_1 && !eventIds_1_1.done && (_a = eventIds_1.return)) _a.call(eventIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var e_1, _a;
    };
    PulseBettingStore.prototype.createStakeViewModel = function (eventId) {
        var _this = this;
        var index = this.currency.pulseBettingStakeValuesSeries.findIndex(function (stake) { return stake === _this.currency.defaultStake; });
        return new data_1.StakeViewModel({
            stakeValue: this.currency.defaultStake,
            currencySign: this.currencySign,
            eventId: eventId,
            index: index,
            isMinusDisabled: index <= 0,
            isPlusDisabled: index === this.currency.pulseBettingStakeValuesSeries.length - 1
        });
    };
    PulseBettingStore.prototype.removeFromWaitingBets = function (eventId) {
        var index = this.awaitingCallback.findIndex(function (bet) { return bet.eventId === eventId; });
        if (index >= 0) {
            this.awaitingCallback.splice(index, 1);
        }
        if (eventId === -1) {
            this.awaitingCallback.splice(0, 1);
        }
        if (this.awaitingCallback.length) {
            setTimeout(this.awaitingCallback[0].func, 250);
        }
    };
    // Method implementation is in progress, the periods population is commented out.
    PulseBettingStore.prototype.setpulseBetMarketViewModelList = function () {
        var result = [];
        var _loop_1 = function (event) {
            if (event.spLines.length === 3) {
                var pulseComponentData = this_1.pulsebetsDataForComponents.find(function (comp) { return comp.pulseBetMetadata.marketId === event.id; });
                if (pulseComponentData) {
                    pulseComponentData.pulseBetMetadata.periods = this_1.formatPeriods(event.spLines);
                    pulseComponentData.winings.winnings = pulseComponentData.wrappedCalculatedPeriods.map(function (period, index) { return ({
                        winningValue: period.formatedWin,
                        winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                        periodNumber: index
                    }); });
                    pulseComponentData.placeBetHandler = this_1.getPulseBetMarketHandler(this_1.isUserLogged, event, pulseComponentData.stakeInputData.stakeValue);
                }
                else {
                    var stakeViewModel = this_1.createStakeViewModel(event.id);
                    var periods = this_1.formatPeriods(event.spLines);
                    var duration = periods[2].endTimeInMilli - periods[0].startTimeInMilli;
                    this_1.pulsebetsDataForComponents.push(new models_1.PulseBetMarketComponentData(stakeViewModel, new models_1.PulseBetMarketAdditionalData({
                        durationInMilli: duration, name: event.typeName, marketId: event.id, branchID: this_1.branchId, currencySign: this_1.currencySign,
                        periods: periods,
                        typeId: event.typeId
                    }), 1000000, this_1.getPulseBetMarketHandler(this_1.isUserLogged, event, stakeViewModel.stakeValue)));
                }
            }
        };
        var this_1 = this;
        try {
            for (var _a = __values(this.events), _b = _a.next(); !_b.done; _b = _a.next()) {
                var event = _b.value;
                _loop_1(event);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return result;
        var e_2, _c;
    };
    PulseBettingStore.prototype.triggerStakeWinningsAnimation = function (eventId) {
        var pulseBetdata = this.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        /* istanbul ignore next */
        if (pulseBetdata) {
            /* istanbul ignore next */
            pulseBetdata.onStakeChangeFading = true;
        }
    };
    PulseBettingStore.prototype.getPulseBetMarketHandler = function (isUserLogged, event, stakeValue) {
        if (isUserLogged) {
            return this.placeBet.bind(this, event.spLines, stakeValue);
        }
        else {
            return this.navHandler.openResponsiveLogin;
        }
    };
    PulseBettingStore.prototype.placeBet = function (lines, stake) {
        this.awaitingCallback.push({
            eventId: lines[0].eventId,
            func: this.betslipUtil.addQAInitilizedSelectionToBetSlip.bind(this.betslipUtil, { lines: lines, stake: stake })
        });
        /* istanbul ignore next */
        this.eventsManager.dispatchEvent("onPulseBetPlacementResult", {
            status: data_1.BetPlacementStatus.InProcess,
            eventId: lines[0].eventId,
            tickedId: 0,
            timeInterval: "0-0",
            errorMessage: ""
        }, true);
        if (this.awaitingCallback.length === 1) {
            /* istanbul ignore next */
            this.awaitingCallback[0].func();
        }
    };
    PulseBettingStore.prototype.formatPeriods = function (lines) {
        if (!lines || !lines[0]) {
            return [];
        }
        var gameProgressMs = lines[0].qaParameter1 * 1000;
        var periods = [];
        try {
            for (var lines_1 = __values(lines), lines_1_1 = lines_1.next(); !lines_1_1.done; lines_1_1 = lines_1.next()) {
                var line = lines_1_1.value;
                var endTime = (line.qaParameter1 * 1000) - gameProgressMs + (line.qaParameter2 * 1000);
                periods.push({
                    europeanOdds: +this.oddsUtil.convertFormat(+line.odds, line.eventTypeId, line.lineTypeId, undefined, 1, undefined, line.branchId, undefined, undefined),
                    startTimeInMilli: (line.qaParameter1 * 1000) - gameProgressMs,
                    endTimeInMilli: endTime
                });
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (lines_1_1 && !lines_1_1.done && (_a = lines_1.return)) _a.call(lines_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return periods;
        var e_3, _a;
    };
    Object.defineProperty(PulseBettingStore, "getInstance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: true,
        configurable: true
    });
    PulseBettingStore.prototype.subscribeToPush = function (data) {
        var events = sb_resp_lib_1.ArrayHelper.ArrayOf(data, Parser_1.Parser.QAEventInfoParser.bind(Parser_1.Parser));
        this.updateStore(events);
        if (this.facade) {
            this.facade.clearDebounce(this.name);
        }
        this.updateBetSlipLines(true);
    };
    PulseBettingStore.prototype.updateStore = function (events) {
        var _loop_2 = function (event) {
            var ev = this_2.events.find(
            /* istanbul ignore next */
            function (evt) { return evt.id === event.id; });
            if (!ev) {
                return "continue";
            }
            ev.lines = event.lines;
        };
        var this_2 = this;
        try {
            for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                var event = events_1_1.value;
                _loop_2(event);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var e_4, _a;
    };
    PulseBettingStore.prototype.updateBetSlipLines = function (isFromPush) {
        if (this.events.length > 0) {
            var request = [];
            var viewKey = 0;
            var responseArray = [];
            try {
                for (var _a = __values(this.events), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var event = _b.value;
                    try {
                        for (var _c = __values(event.lines), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var line = _d.value;
                            request.push([false, viewKey, event.id, event.typeId, line.id, line.odds, 0, 0, false, "0_" + this.masterEventId + "_0", false, true].join(","));
                            responseArray[viewKey++] = { event: event, line: line };
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
                }
                finally { if (e_6) throw e_6.error; }
            }
            this.dataComposite.bettingPageMethods.updateRegularCartItems(request.join("@"), this.successfulUpdateRegularCartItemCallback.bind(this, responseArray), this.errorCallback);
            if (!isFromPush) {
                this.setUpdateEventsData();
            }
        }
        var e_6, _f, e_5, _e;
    };
    PulseBettingStore.prototype.setUpdateEventsData = function () {
        this.updateEventsTimeout = setTimeout(this.updateBetSlipLines, 5000);
    };
    PulseBettingStore.prototype.successfullUpdateEventsCallback = function (response) {
        var data = eval(response);
        this.events = sb_resp_lib_1.ArrayHelper.ArrayOf(data, Parser_1.Parser.QAEventInfoParser.bind(Parser_1.Parser));
        this.updateBetSlipLines();
    };
    /**istanbuld ignore next */
    PulseBettingStore.prototype.successfulUpdateRegularCartItemCallback = function (request, response) {
        var jsonData = eval(response);
        for (var key in jsonData) {
            if (jsonData[key]) {
                if (jsonData[key] !== "-1") {
                    if (request[key]) {
                        var event = request[key].event;
                        var evt = event;
                        evt.masterEventId = this.masterEventId;
                        var item = Parser_1.Parser.QALiveSlipSelectionParser(evt, jsonData[key]);
                        item.lineId = request[key].line.id;
                        item.odds = item.odds || request[key].line.odds;
                        this.parseUpdateRegularCartItem(item);
                    }
                }
                else {
                    this.removeFromPulseBets(request[key].event.id);
                }
            }
        }
        this.setpulseBetMarketViewModelList();
    };
    PulseBettingStore.prototype.removeFromPulseBets = function (eventId) {
        var indexToRemove = this.eventIds.findIndex(function (eventModel) { return eventModel.id === eventId; });
        if (indexToRemove !== -1) {
            this.eventIds.splice(indexToRemove, 1);
        }
        indexToRemove = this.events.findIndex(function (qaEvent) { return qaEvent.id === eventId; });
        if (indexToRemove !== -1) {
            this.events.splice(indexToRemove, 1);
        }
        indexToRemove = this.pulsebetsDataForComponents.findIndex(function (pbComponent) { return pbComponent.pulseBetMetadata.marketId === eventId; });
        if (indexToRemove !== -1) {
            this.pulsebetsDataForComponents.splice(indexToRemove, 1);
        }
    };
    PulseBettingStore.prototype.errorCallback = function (response) {
    };
    //TODO: write tests
    /*istanbul ignore next */
    PulseBettingStore.prototype.parseUpdateRegularCartItem = function (item) {
        var observableEvent = this.events.find(function (ev) { return ev.id === item.eventId; });
        /* istanbul ignore next */
        if (observableEvent) {
            if (observableEvent.spLines.length) {
                var index = observableEvent.spLines.findIndex(function (spLine) { return spLine.lineId === item.lineId; });
                if (index >= 0) {
                    /* istanbul ignore next */
                    observableEvent.spLines[index] = item;
                }
                else {
                    observableEvent.spLines.push(item);
                }
            }
            else {
                observableEvent.spLines.push(item);
            }
            return observableEvent;
        }
        /* istanbul ignore next */
        return observableEvent;
    };
    /**istanbul ignore next */
    PulseBettingStore.prototype.setParams = function (masterEventId, events) {
        if (this.masterEventId === masterEventId && events.length === this.eventIds.length) {
            return;
        }
        this.clear();
        this.eventsManager.addEventListener("onPulseBetWaitingResponse", this, this.removeFromWaitingBets, true);
        this.masterEventId = masterEventId;
        this.eventIds = events;
        var updateString = "";
        try {
            for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
                var item = events_2_1.value;
                updateString += item.id + "#" + item.type + "@";
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (events_2_1 && !events_2_1.done && (_a = events_2.return)) _a.call(events_2);
            }
            finally { if (e_7) throw e_7.error; }
        }
        if (updateString.length) {
            this.dataComposite.pageMethods.UpdateEvents(updateString, this.successfullUpdateEventsCallback, this.errorCallback);
        }
        var e_7, _a;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], PulseBettingStore.prototype, "isUserLogged", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof data_1.StakeCurrencyContainer !== "undefined" && data_1.StakeCurrencyContainer) === "function" && _a || Object)
    ], PulseBettingStore.prototype, "currency", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "eventIds", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "events", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "pulsebetsDataForComponents", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBettingStore.prototype, "awaitingCallback", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Array)
    ], PulseBettingStore.prototype, "setpulseBetMarketViewModelList", null);
    __decorate([
        debounce_decorator_1.default(10),
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "triggerStakeWinningsAnimation", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Array)
    ], PulseBettingStore.prototype, "formatPeriods", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "updateStore", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "updateBetSlipLines", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "successfullUpdateEventsCallback", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Object]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "successfulUpdateRegularCartItemCallback", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof models_1.QALiveSlipSelection !== "undefined" && models_1.QALiveSlipSelection) === "function" && _b || Object]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "parseUpdateRegularCartItem", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Array]),
        __metadata("design:returntype", void 0)
    ], PulseBettingStore.prototype, "setParams", null);
    return PulseBettingStore;
    var _a, _b;
}());
exports.PulseBettingStore = PulseBettingStore;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var QASlipSelection_1 = __webpack_require__(16);
var mobx_1 = __webpack_require__(1);
var QALiveSlipSelection = /** @class */ (function (_super) {
    __extends(QALiveSlipSelection, _super);
    function QALiveSlipSelection(source) {
        var _this = 
        /* istanbul ignore next */
        _super.call(this, source) || this;
        _this.danger = source.danger;
        _this.score1 = source.score1;
        _this.score2 = source.score2;
        return _this;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], QALiveSlipSelection.prototype, "danger", void 0);
    return QALiveSlipSelection;
}(QASlipSelection_1.QASlipSelection));
exports.QALiveSlipSelection = QALiveSlipSelection;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSlipSelection_1 = __webpack_require__(17);
var QASlipSelection = /** @class */ (function (_super) {
    __extends(QASlipSelection, _super);
    function QASlipSelection(source) {
        var _this = _super.call(this, source) || this;
        _this.eventDate = source.eventDate;
        _this.lineTypeId = source.lineTypeId;
        _this.betTypeId = source.betTypeId;
        _this.useEventName = source.useEventName;
        _this.eventName = source.eventName;
        _this.lineName = source.lineName;
        _this.asianLineName = source.asianLineName;
        _this.mappedLineTypeId = source.mappedLineTypeId;
        _this.swapped = source.swapped;
        _this.splitTypeId = source.splitTypeId;
        _this.SISEventId = source.SISEventId;
        _this.GBSEventId = source.GBSEventId;
        _this.feedEventId = source.feedEventId;
        _this.feedProviderId = source.feedProviderId;
        _this.isEachWayEnabled = source.isEachWayEnabled;
        _this.placeTermsId = source.placeTermsId;
        _this.relatedToId = source.relatedToId;
        _this.eachWayMaxStake = source.eachWayMaxStake;
        _this.eachWayMaxStakeCombo = source.eachWayMaxStakeCombo;
        _this.eachWayComboBetIsEnabled = source.eachWayComboBetIsEnabled;
        _this.eachWayMinBet = source.eachWayMinBet;
        _this.qaParameter1 = source.qaParameter1;
        _this.qaParameter2 = source.qaParameter2;
        return _this;
    }
    return QASlipSelection;
}(BaseSlipSelection_1.BaseSlipSelection));
exports.QASlipSelection = QASlipSelection;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var BaseSlipSelection = /** @class */ (function () {
    function BaseSlipSelection(source) {
        this.masterEventId = source.masterEventId;
        this.eventId = source.eventId;
        this.type = source.type;
        this.lineId = source.lineId;
        this.leagueId = source.leagueId;
        this.valid = true;
        this.final = true;
        this.lastUpdate = new Date();
        this.branchId = source.branchId;
        this.branchName = source.branchName;
        this.leagueName = source.leagueName;
        this.eventTypeId = source.eventTypeId;
        this.eventTypeName = source.eventTypeName;
        this.oppositeEventTypeId = source.oppositeEventTypeId;
        this.team1Name = source.team1Name;
        this.team2Name = source.team2Name;
        this.liveGroupId = source.liveGroupId;
        this.preLiveGroupId = source.preLiveGroupId;
        this.maxBet = source.maxBet;
        this.minBet = source.minBet;
        this.waitingAllowed = source.waitingAllowed;
        this.singleSelectionRisk = source.singleSelectionRisk;
        this.lineTypeName = source.lineTypeName;
        this.initilized = true;
        this.odds = source.odds;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BaseSlipSelection.prototype, "lastUpdate", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], BaseSlipSelection.prototype, "maxBet", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], BaseSlipSelection.prototype, "minBet", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], BaseSlipSelection.prototype, "odds", void 0);
    return BaseSlipSelection;
}());
exports.BaseSlipSelection = BaseSlipSelection;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var store_1 = __webpack_require__(8);
var AcceptedBetModel_1 = __webpack_require__(18);
var EventErrorModel_1 = __webpack_require__(19);
var BetPlacementResultType_1 = __webpack_require__(20);
var BetPlacementStatus_1 = __webpack_require__(21);
var BetPlacementModel_1 = __webpack_require__(22);
var sb_resp_lib_1 = __webpack_require__(2);
var helpers_1 = __webpack_require__(23);
sb_resp_lib_1.initPolyfills();
var PulseBetMarketsData = /** @class */ (function () {
    function PulseBetMarketsData(provider, dict, cmsConfig, oddsUtil, betSlipUtil, navHandler) {
        var _this = this;
        this.stakeInputDataView = mobx_1.createTransformer(function (eventId) {
            var pulseBetdata = _this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
            if (pulseBetdata) {
                return {
                    stake: pulseBetdata.stakeInputData.stakeValue,
                    eventId: eventId,
                    stakeFormatted: _this.getUserStakeFormatted(pulseBetdata.stakeInputData.stakeValue),
                    isMinusDisabled: _this.isMinusDisabled(eventId) || false,
                    isPlusDisabled: _this.isPlusDisabled(eventId) || false,
                    stakeDown: _this.stakeDown,
                    stakeUp: _this.stakeUp
                };
            }
            return {
                stake: _this.store.pulsebetsDataForComponents[0].stake,
                eventId: eventId,
                stakeFormatted: _this.getUserStakeFormatted(_this.store.pulsebetsDataForComponents[0].stakeInputData.stakeValue),
                isMinusDisabled: _this.isMinusDisabled(eventId) || false,
                isPlusDisabled: _this.isPlusDisabled(eventId) || false,
                stakeDown: _this.stakeDown,
                stakeUp: _this.stakeUp
            };
        });
        this.provider = provider;
        this.name = "PulseBetsMarket";
        this.userInfo = provider.userInfo;
        this.navHandler = navHandler;
        this.eventsManager = new EventsManager();
        this.branchId = 1;
        this.store = store_1.PulseBettingStore.getInstance;
        this.store.dataComposite = provider;
        this.dict = dict;
        this.stakeCurrencies = cmsConfig.stakeSeries;
        this.userInfo.onLogin[this.name] = this.onLogin;
        this.userInfo.onLogout[this.name] = this.onLogout;
        this.isDanger = false;
        this.calculatedPeriodHelperDependency = helpers_1.CalculatedPeriodHelper.getInstance();
        this.userInfo.current ? this.onLogin() : this.onLogout();
        this.eventsBetPlacementResult = [];
        this.oddsUtil = oddsUtil;
        this.betSlipUtil = betSlipUtil;
        this.eventsManager.addEventListener("onMasterEventDanger", this, this.onMasterEventDanger, true);
        this.store.currency = this.currency;
        this.store.oddsUtil = this.oddsUtil;
        this.store.betslipUtil = this.betSlipUtil;
        this.store.isUserLogged = this.isUserLogged;
        this.store.navHandler = navHandler;
        this.eventsAutoCloseTimeout = [];
        this.timeoutConstantForAutoClose = cmsConfig.autoCloseTimeout;
    }
    PulseBetMarketsData.prototype.setParams = function (masterEventId, eventIds, branchID) {
        if (this.store.eventIds.length === eventIds.length) {
            return;
        }
        this.eventsBetPlacementResult = [];
        this.store.setParams(masterEventId, eventIds);
        this.branchId = branchID;
        this.initAllBetPlacementModel(eventIds);
        this.eventsManager.addEventListener("onPulseBetPlacementResult", this, this.onPulseBetPlacementResult, true);
    };
    PulseBetMarketsData.prototype.getUserStakeFormatted = function (stake) {
        return this.isUserLogged ? this.calculatedPeriodHelperDependency.formatWinnings(stake) :
            stake.toString();
    };
    PulseBetMarketsData.prototype.deactivate = function () {
        this.eventsManager.removeEventListener("onPulseBetPlacementResult", this, true);
        this.store.clear();
        this.eventsBetPlacementResult = [];
    };
    Object.defineProperty(PulseBetMarketsData.prototype, "currency", {
        get: function () {
            return this.isUserLogged ? this.getUserCurrency() : this.getDefaultCurrency();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @function  onLogin  executed on Login of customer
     */
    PulseBetMarketsData.prototype.onLogin = function () {
        this.isUserLogged = true;
        this.store.currencySign = this.userInfo.current.currencyCode;
        this.store.isUserLogged = true;
        this.calculatedPeriodHelperDependency.setCurrentUserInfo(this.userInfo.current);
    };
    PulseBetMarketsData.prototype.addSuffix = function (eventId) {
        var event = this.store.events.find(function (ev) { return ev.id === eventId && (ev.typeId === store_1.PulseBetsTypes.ThirtySecPulse || ev.typeId === store_1.PulseBetsTypes.OneMinPulse); });
        if (event) {
            return this.dict.Sec;
        }
        return "";
    };
    /**
     * @function  onLogout execute on Logout of customer
     */
    PulseBetMarketsData.prototype.onLogout = function () {
        this.isUserLogged = false;
        this.store.currencySign = "";
        this.store.isUserLogged = false;
        this.calculatedPeriodHelperDependency.setCurrentUserInfo(undefined);
    };
    Object.defineProperty(PulseBetMarketsData.prototype, "placeButtonText", {
        /**
        *  Gets the text for the place bet button
        */
        get: function () {
            if (this.isDanger) {
                return this.dict.Suspended;
            }
            return this.isUserLogged ? this.dict.PlaceBet : this.dict.PleaseLoginToPlaceBet;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * gets the default currency if there is no default it gets the first
     */
    PulseBetMarketsData.prototype.getDefaultCurrency = function () {
        var container = this.stakeCurrencies.find(function (currency) { return currency.isDefault; }) || this.stakeCurrencies[0];
        return container;
    };
    /**
     *  gets the StakeCurrencyContainer of the user
     */
    PulseBetMarketsData.prototype.getUserCurrency = function () {
        var _this = this;
        return this.stakeCurrencies.find(function (currency) { return currency.id === _this.userInfo.current.currencyId; }) || this.getDefaultCurrency();
    };
    PulseBetMarketsData.prototype.setWining = function (eventId) {
        var pulseBetdata = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        if (pulseBetdata) {
            pulseBetdata.winings.winnings = pulseBetdata.wrappedCalculatedPeriods.map(function (period, index) { return ({
                winningValue: period.formatedWin,
                winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                periodNumber: index,
            }); });
            pulseBetdata.onStakeChangeFading = false;
            this.store.triggerStakeWinningsAnimation(eventId);
        }
    };
    /**
        *
        * @param eventId  of the market you increase the stake
    */
    PulseBetMarketsData.prototype.stakeUp = function (eventId) {
        var pulseBetData = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        if (pulseBetData) {
            var index = this.currency.pulseBettingStakeValuesSeries.findIndex(function (stake) { return stake === (pulseBetData && pulseBetData.stakeInputData.stakeValue); });
            pulseBetData.stakeInputData.stakeValue = this.currency.pulseBettingStakeValuesSeries[++index];
            pulseBetData.stakeInputData.index = index;
            this.isPlusDisabled(eventId);
            this.isMinusDisabled(eventId);
            this.setWining(eventId);
            var ev = this.store.events.find(function (evnt) { return evnt.id === eventId; });
            if (ev) {
                pulseBetData.externalPlaceBetHandler = this.store.getPulseBetMarketHandler(this.isUserLogged, ev, pulseBetData.stakeInputData.stakeValue);
            }
        }
    };
    /**
         *
         * @param eventId  of the market is - disabled
    */
    PulseBetMarketsData.prototype.isMinusDisabled = function (eventId) {
        var pulseBetdata = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        return pulseBetdata && pulseBetdata.stakeInputData.index <= 0 || false;
    };
    /**
        *
        * @param eventId  of the market is + disabled
    */
    PulseBetMarketsData.prototype.isPlusDisabled = function (eventId) {
        var pulseBetdata = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        return pulseBetdata && pulseBetdata.stakeInputData.index === this.currency.pulseBettingStakeValuesSeries.length - 1 || false;
    };
    /**
     *
     * @param eventId  of the market you decrease the stake
     */
    PulseBetMarketsData.prototype.stakeDown = function (eventId) {
        var pulseBetData = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        if (pulseBetData) {
            var index = this.currency.pulseBettingStakeValuesSeries.findIndex(function (stake) { return stake === (pulseBetData && pulseBetData.stakeInputData.stakeValue); });
            pulseBetData.stakeInputData.stakeValue = this.currency.pulseBettingStakeValuesSeries[--index];
            pulseBetData.stakeInputData.index = index;
            this.isPlusDisabled(eventId);
            this.isMinusDisabled(eventId);
            this.setWining(eventId);
            var ev = this.store.events.find(function (evnt) { return evnt.id === eventId; });
            if (ev) {
                pulseBetData.externalPlaceBetHandler = this.store.getPulseBetMarketHandler(this.isUserLogged, ev, pulseBetData.stakeInputData.stakeValue);
            }
        }
    };
    PulseBetMarketsData.prototype.onMasterEventDanger = function (dangerResponse) {
        if (dangerResponse === true || dangerResponse === false) {
            this.isDanger = dangerResponse;
        }
    };
    /**
     * @function isEventIdExistInStore check if an event id is in the eventIds array in the store
     *
     * @param currentEventId number which is the ID of the event
     */
    PulseBetMarketsData.prototype.isEventIdExistInStore = function (currentEventId) {
        return this.store.eventIds.some(function (mod) { return mod.id === currentEventId; });
    };
    /**
     * @function closeEventError function called when the close button of the error message component is clicked
     *
     * @param eventId Id of pulse bet market(event)
     */
    PulseBetMarketsData.prototype.closeEventError = function (eventId) {
        var currentEvent = this.eventsBetPlacementResult.find(function (event) { return event.eventId === eventId; });
        if (currentEvent) {
            currentEvent.status = BetPlacementStatus_1.BetPlacementStatus.NotStarted;
            currentEvent.error.message = "";
        }
    };
    PulseBetMarketsData.prototype.goToMyPulseBet = function () {
        this.eventsManager.dispatchEvent("onOpenMyPulseBet", this, true);
    };
    PulseBetMarketsData.prototype.getAcceptBetModel = function (ticketId, timeInterval, eventId) {
        return new AcceptedBetModel_1.AcceptedBetModel({
            ticketId: ticketId,
            message: this.dict.BetWasAccepted,
            ticketLabel: this.dict.TicketLabel,
            timeInterval: timeInterval,
            buttonLabel: this.dict.GoToMyPulseBets,
            handler: this.goToMyPulseBet.bind(this),
            areaHandler: this.setBetPlacementStatusToNotStarted.bind(this, eventId)
        });
    };
    PulseBetMarketsData.prototype.getEventErrorModel = function (errorMessage, eventId) {
        return new EventErrorModel_1.EventErrorModel({
            message: errorMessage,
            handler: this.closeEventError.bind(this, eventId)
        });
    };
    PulseBetMarketsData.prototype.setSuccessfulBetPlacementResult = function (result, eventBetPlacementResult) {
        eventBetPlacementResult.status = BetPlacementStatus_1.BetPlacementStatus.Success;
        eventBetPlacementResult.success.ticketId = result.ticketId || "";
        eventBetPlacementResult.success.timeInterval = result.timeInterval || "";
        eventBetPlacementResult.error.message = "";
    };
    PulseBetMarketsData.prototype.setBetPlacementStatusToNotStarted = function (eventId) {
        clearTimeout(this.eventsAutoCloseTimeout[eventId]);
        var pulsebetsDataForComponents = this.store.pulsebetsDataForComponents.find(function (data) { return data.pulseBetMetadata.marketId === eventId; });
        var eventBetPlacementResult = this.eventsBetPlacementResult.find(function (bet) { return bet.eventId === eventId; });
        if (pulsebetsDataForComponents && eventBetPlacementResult) {
            this.setBetPlacementModel({
                status: BetPlacementStatus_1.BetPlacementStatus.NotStarted,
                eventId: eventId,
            }, eventBetPlacementResult);
        }
    };
    PulseBetMarketsData.prototype.checkStatusForNotStartedAndAddTimerForAutoClose = function (status, eventId) {
        if (BetPlacementStatus_1.BetPlacementStatus.Success === status) {
            this.eventsAutoCloseTimeout[eventId] = setTimeout(this.setBetPlacementStatusToNotStarted.bind(this, eventId), this.timeoutConstantForAutoClose);
        }
    };
    PulseBetMarketsData.prototype.setBetPlacementModel = function (result, eventBetPlacementResult) {
        switch (result.status) {
            case BetPlacementStatus_1.BetPlacementStatus.NotStarted:
                eventBetPlacementResult.status = BetPlacementStatus_1.BetPlacementStatus.NotStarted;
                break;
            case BetPlacementStatus_1.BetPlacementStatus.InProcess:
                eventBetPlacementResult.status = BetPlacementStatus_1.BetPlacementStatus.InProcess;
                eventBetPlacementResult.error.message = "";
                break;
            case BetPlacementStatus_1.BetPlacementStatus.Error:
                eventBetPlacementResult.status = BetPlacementStatus_1.BetPlacementStatus.Error;
                eventBetPlacementResult.error.message = result.errorMessage || "";
                break;
            case BetPlacementStatus_1.BetPlacementStatus.Success:
                this.setSuccessfulBetPlacementResult(result, eventBetPlacementResult);
                this.eventsManager.dispatchEvent("onSuccessfullyPlacedBet", this, true);
                break;
        }
    };
    PulseBetMarketsData.prototype.initBetPlacementModel = function (eventId) {
        return new BetPlacementModel_1.BetPlacementModel({
            eventId: eventId,
            status: BetPlacementStatus_1.BetPlacementStatus.NotStarted,
            error: this.getEventErrorModel("", eventId),
            success: this.getAcceptBetModel("", "", eventId)
        });
    };
    PulseBetMarketsData.prototype.initAllBetPlacementModel = function (eventIds) {
        try {
            for (var eventIds_1 = __values(eventIds), eventIds_1_1 = eventIds_1.next(); !eventIds_1_1.done; eventIds_1_1 = eventIds_1.next()) {
                var item = eventIds_1_1.value;
                this.eventsBetPlacementResult.push(this.initBetPlacementModel(item.id));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (eventIds_1_1 && !eventIds_1_1.done && (_a = eventIds_1.return)) _a.call(eventIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var e_1, _a;
    };
    PulseBetMarketsData.prototype.onPulseBetPlacementResult = function (result) {
        if (this.isEventIdExistInStore(result.eventId)) {
            var eventBetPlacementResult = this.eventsBetPlacementResult.find(function (mod) { return mod.eventId === result.eventId; });
            if (!eventBetPlacementResult) {
                this.eventsBetPlacementResult.push(new BetPlacementModel_1.BetPlacementModel({
                    eventId: result.eventId,
                    status: result.status,
                    error: this.getEventErrorModel(result.errorMessage || "", result.eventId),
                    success: this.getAcceptBetModel(result.ticketId || "", result.timeInterval || "", result.eventId)
                }));
            }
            else {
                this.setBetPlacementModel(result, eventBetPlacementResult);
                this.checkStatusForNotStartedAndAddTimerForAutoClose(result.status, result.eventId);
            }
        }
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], PulseBetMarketsData.prototype, "timer", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], PulseBetMarketsData.prototype, "periodStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], PulseBetMarketsData.prototype, "isUserLogged", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], PulseBetMarketsData.prototype, "isDanger", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBetMarketsData.prototype, "eventsBetPlacementResult", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Array, Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "setParams", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketsData.prototype, "currency", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "onLogin", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "onLogout", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketsData.prototype, "placeButtonText", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "setWining", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "stakeUp", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "stakeDown", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "onMasterEventDanger", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "closeEventError", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "setBetPlacementStatusToNotStarted", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof BetPlacementResultType_1.BetPlacementResultType !== "undefined" && BetPlacementResultType_1.BetPlacementResultType) === "function" && _a || Object]),
        __metadata("design:returntype", void 0)
    ], PulseBetMarketsData.prototype, "onPulseBetPlacementResult", null);
    return PulseBetMarketsData;
    var _a;
}());
exports.PulseBetMarketsData = PulseBetMarketsData;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var AcceptedBetModel = /** @class */ (function () {
    function AcceptedBetModel(source) {
        this.ticketId = source.ticketId;
        this.message = source.message;
        this.ticketLabel = source.ticketLabel;
        this.timeInterval = source.timeInterval;
        this.buttonLabel = source.buttonLabel;
        this.handler = source.handler;
        this.areaHandler = source.areaHandler;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AcceptedBetModel.prototype, "ticketId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AcceptedBetModel.prototype, "timeInterval", void 0);
    return AcceptedBetModel;
}());
exports.AcceptedBetModel = AcceptedBetModel;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var EventErrorModel = /** @class */ (function () {
    function EventErrorModel(source) {
        this.message = source.message;
        this.handler = source.handler;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], EventErrorModel.prototype, "message", void 0);
    return EventErrorModel;
}());
exports.EventErrorModel = EventErrorModel;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var BetPlacementModel = /** @class */ (function () {
    function BetPlacementModel(source) {
        this.eventId = source.eventId;
        this.status = source.status;
        this.error = source.error;
        this.success = source.success;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], BetPlacementModel.prototype, "status", void 0);
    return BetPlacementModel;
}());
exports.BetPlacementModel = BetPlacementModel;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(83));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var StakeViewModel = /** @class */ (function () {
    function StakeViewModel(source) {
        this.stakeValue = source.stakeValue;
        this.currencySign = source.currencySign;
        this.eventId = source.eventId;
        this.isMinusDisabled = source.isMinusDisabled;
        this.isPlusDisabled = source.isPlusDisabled;
        this.index = source.index;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], StakeViewModel.prototype, "stakeValue", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], StakeViewModel.prototype, "currencySign", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], StakeViewModel.prototype, "isMinusDisabled", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], StakeViewModel.prototype, "isPlusDisabled", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], StakeViewModel.prototype, "index", void 0);
    return StakeViewModel;
}());
exports.StakeViewModel = StakeViewModel;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(85));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * StakeCurrencyContainer defines Stake currency container
 *
 * @typedef StakeCurrencyContainer
 * @type {Object}
 * @property {defaultStake}  the default stake of the currency
 * @property {isDefault} is the default currency
 * @property {id} ID of the currency
 * @property {pulseBettingStakeValuesSeries} Array of stake series numbers
 */
var StakeCurrencyContainer = /** @class */ (function () {
    function StakeCurrencyContainer(source) {
        this.defaultStake = source.defaultStake;
        this.isDefault = source.isDefault;
        this.pulseBettingStakeValuesSeries = source.pulseBettingStakeValuesSeries;
        this.id = source.id;
    }
    return StakeCurrencyContainer;
}());
exports.StakeCurrencyContainer = StakeCurrencyContainer;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(21));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Default debounce duration (in ms) */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = outerDecorator;
exports.debounce = debounce;
var DEFAULT_DEBOUNCE_DURATION = 500;

exports.DEFAULT_DEBOUNCE_DURATION = DEFAULT_DEBOUNCE_DURATION;
/** Decorates a class method so that it is debounced by the specified duration */

function outerDecorator(duration) {
  return function innerDecorator(target, key, descriptor) {
    return {
      configurable: true,
      enumerable: descriptor.enumerable,
      get: function getter() {
        // Attach this function to the instance (not the class)
        Object.defineProperty(this, key, {
          configurable: true,
          enumerable: descriptor.enumerable,
          value: debounce(descriptor.value, duration)
        });

        return this[key];
      }
    };
  };
}

/** Debounces the specified function and returns a wrapper function */

function debounce(method) {
  var duration = arguments.length <= 1 || arguments[1] === undefined ? DEFAULT_DEBOUNCE_DURATION : arguments[1];

  var timeoutId = undefined;

  function debounceWrapper() {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    debounceWrapper.clear();

    timeoutId = setTimeout(function () {
      timeoutId = null;
      method.apply(_this, args);
    }, duration);
  }

  debounceWrapper.clear = function () {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounceWrapper;
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(89));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CalculatedPeriod = /** @class */ (function () {
    function CalculatedPeriod(source) {
        this.index = source.index;
        this.isLast = source.isLast;
        this.period = source.period;
        this.calculatedWin = source.calculatedWin;
        this.formatedWin = source.formatedWin;
        this.periodDurationInMilli = source.periodDurationInMilli;
        this.relativePercentFromTotal = source.relativePercentFromTotal;
        this.absolutePercentFromTotal = source.absolutePercentFromTotal;
        this.invertedStartTimeInMinutesFormat = source.invertedStartTimeInMinutesFormat;
        this.absoluteToGameFormattedGameStart = source.absoluteToGameFormattedGameStart;
        this.absoluteGameFormattedGameEnd = source.absoluteGameFormattedGameEnd;
        this.absoluteToGameStartInMilli = source.absoluteToGameStartInMilli;
        this.absoluteToGameEndInMilli = source.absoluteToGameEndInMilli;
        this.relativeRangeFormatted = source.relativeRangeFormatted;
        this.periodProgressState = source.periodProgressState;
    }
    return CalculatedPeriod;
}());
exports.CalculatedPeriod = CalculatedPeriod;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(91));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Incident = /** @class */ (function () {
    function Incident(source) {
        this.incidentId = source.incidentId;
        this.incidentName = source.incidentName;
        this.incidentTimeInMilli = source.incidentTimeInMilli;
    }
    return Incident;
}());
exports.Incident = Incident;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(93));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var ViewModel = __webpack_require__(6);
var WinningsDataModel_1 = __webpack_require__(10);
var OpenPulseBetViewModel = /** @class */ (function (_super) {
    __extends(OpenPulseBetViewModel, _super);
    function OpenPulseBetViewModel(stake, gain, pulseBetMetadata, startTimeOfBet, currentGameProgress, purchaseId, hasOddsChangedHandler, betAgainHandler, backToBetPlacementHandler, trackColor) {
        var _this = _super.call(this, stake, pulseBetMetadata, currentGameProgress) || this;
        _this.trackColor = trackColor;
        _this.gain = gain;
        _this.startTimeOfBet = startTimeOfBet;
        _this.purchaseId = purchaseId;
        _this.isFinished = false;
        _this.hasOddsChangedHandler = hasOddsChangedHandler;
        _this.betAgainHandler = betAgainHandler;
        _this.backToBetPlacementHandler = backToBetPlacementHandler;
        _this.progressInMilli = 0;
        _this.animationStarted = Date.now();
        return _this;
    }
    Object.defineProperty(OpenPulseBetViewModel.prototype, "formatedGain", {
        get: function () {
            return this.calculatedPeriodHelperDependency.formatWinnings(this.gain);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenPulseBetViewModel.prototype, "uniqueKey", {
        get: function () {
            return "purchaseId:" + this.purchaseId + "market:" + this.pulseBetMetadata.marketId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OpenPulseBetViewModel.prototype, "periodFrames", {
        // @computed get winningsData(): WinningsDataModel {
        //     return {
        //         winnings: this.wrappedCalculatedPeriods.map((period, index) => (
        //             {
        //                 winningValue: period.formatedWin,
        //                 winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
        //                 periodNumber: index
        //             })),
        //         branchID: this.pulseBetMetadata.branchID
        //     }
        // }
        get: function () {
            /* istanbul ignore next */
            var wrappedPeriods = this.calculatedPeriodHelperDependency.wrappedCalculatedPeriods(this.stake, this.pulseBetMetadata);
            return wrappedPeriods.map(function (p) {
                return ({
                    start: p.absoluteToGameFormattedGameStart,
                    end: p.absoluteGameFormattedGameEnd
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    OpenPulseBetViewModel.prototype.isBetExpired = function () {
        var duration = 0;
        try {
            for (var _a = __values(this.pulseBetProgressData.periods), _b = _a.next(); !_b.done; _b = _a.next()) {
                var period = _b.value;
                duration += period.duration;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        duration *= 1000;
        return this.isFinished || this.pulseBetProgressData.expiredBetProgressInMilliseconds >= duration;
        var e_1, _c;
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof WinningsDataModel_1.WinningsDataModel !== "undefined" && WinningsDataModel_1.WinningsDataModel) === "function" && _a || Object)
    ], OpenPulseBetViewModel.prototype, "winningsData", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], OpenPulseBetViewModel.prototype, "finishedState", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], OpenPulseBetViewModel.prototype, "isFinished", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "formatedGain", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "uniqueKey", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], OpenPulseBetViewModel.prototype, "periodFrames", null);
    return OpenPulseBetViewModel;
    var _a;
}(ViewModel.BasicPulseBetViewModel));
exports.OpenPulseBetViewModel = OpenPulseBetViewModel;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
/**
* WinningsDataModel defines the input data and status of the winnings for particular event
*
* @typedef WinningsDataModel
* @type {type}
* @property {winnings} Winnings array of objects which contains the winning value and the current status
* @property {branchID} BranchId the id number of the current sport
*/
var WinningsDataModel = /** @class */ (function () {
    function WinningsDataModel(source) {
        this.winnings = source.winnings;
        this.branchID = source.branchID;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], WinningsDataModel.prototype, "winnings", void 0);
    return WinningsDataModel;
}());
exports.WinningsDataModel = WinningsDataModel;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(96));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus[ProgressStatus["PreRun"] = 0] = "PreRun";
    ProgressStatus[ProgressStatus["Current"] = 1] = "Current";
    ProgressStatus[ProgressStatus["Resulting"] = 2] = "Resulting";
    ProgressStatus[ProgressStatus["PostRun"] = 3] = "PostRun";
})(ProgressStatus = exports.ProgressStatus || (exports.ProgressStatus = {}));
var PeriodProgressState = /** @class */ (function () {
    function PeriodProgressState(source) {
        this.progressStatus = source.progressStatus;
        this.periodRelativeProgressInMilli = source.periodRelativeProgressInMilli;
        this.relativePercentProgress = source.relativePercentProgress;
    }
    return PeriodProgressState;
}());
exports.PeriodProgressState = PeriodProgressState;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(98));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var PulseBetMarketAdditionalData = /** @class */ (function () {
    function PulseBetMarketAdditionalData(source) {
        this.name = source.name;
        this.durationInMilli = source.durationInMilli;
        this.marketId = source.marketId;
        this.currencySign = source.currencySign;
        this.periods = source.periods;
        this.branchID = source.branchID;
        this.typeId = source.typeId || 0;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], PulseBetMarketAdditionalData.prototype, "periods", void 0);
    return PulseBetMarketAdditionalData;
}());
exports.PulseBetMarketAdditionalData = PulseBetMarketAdditionalData;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(100));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var ViewModel_1 = __webpack_require__(6);
var WinningsDataModel_1 = __webpack_require__(10);
var PulseBetMarketComponentData = /** @class */ (function (_super) {
    __extends(PulseBetMarketComponentData, _super);
    function PulseBetMarketComponentData(stakeInputData, pulseBetMetadata, gameProgressInMilli, placeBetHandler) {
        var _this = _super.call(this, stakeInputData.stakeValue, pulseBetMetadata, gameProgressInMilli) || this;
        _this.stakeInputData = stakeInputData;
        _this.placeBetHandler = _this.placeBetHandler.bind(_this);
        _this.externalPlaceBetHandler = placeBetHandler ? placeBetHandler : function () { };
        _this.onStakeChangeFading = false;
        var count = 1;
        _this.winings = {
            winnings: _this.wrappedCalculatedPeriods.map(function (period) { return ({
                winningValue: period.formatedWin,
                winningStatus: period.periodProgressState ? period.periodProgressState.progressStatus : undefined,
                periodNumber: count++
            }); }),
            branchID: _this.pulseBetMetadata.branchID
        };
        return _this;
    }
    Object.defineProperty(PulseBetMarketComponentData.prototype, "wrappedCalculatedPeriods", {
        get: function () {
            return this.calculatedPeriodHelperDependency.wrappedCalculatedPeriodsStateless(this.stakeInputData.stakeValue, this.pulseBetMetadata);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PulseBetMarketComponentData.prototype, "periodFrames", {
        get: function () {
            return this.wrappedCalculatedPeriods.map(function (p) { return p.relativeRangeFormatted; });
        },
        enumerable: true,
        configurable: true
    });
    PulseBetMarketComponentData.prototype.placeBetHandler = function () {
        // if (this.externalPlaceBetHandler) {
        //     this.externalPlaceBetHandler(this.stake, this.pulseBetMetadata, this.gameProgressInMilli);
        // }
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], PulseBetMarketComponentData.prototype, "onStakeChangeFading", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof WinningsDataModel_1.WinningsDataModel !== "undefined" && WinningsDataModel_1.WinningsDataModel) === "function" && _a || Object)
    ], PulseBetMarketComponentData.prototype, "winings", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "wrappedCalculatedPeriods", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], PulseBetMarketComponentData.prototype, "periodFrames", null);
    return PulseBetMarketComponentData;
    var _a;
}(ViewModel_1.BasicPulseBetViewModel));
exports.PulseBetMarketComponentData = PulseBetMarketComponentData;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(102));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var PulseBetPeriod = /** @class */ (function () {
    function PulseBetPeriod(source) {
        this.startTimeInMilli = source.startTimeInMilli;
        this.endTimeInMilli = source.endTimeInMilli;
        this.europeanOdds = source.europeanOdds;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], PulseBetPeriod.prototype, "europeanOdds", void 0);
    return PulseBetPeriod;
}());
exports.PulseBetPeriod = PulseBetPeriod;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(104));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PeriodViewDataModel = /** @class */ (function () {
    function PeriodViewDataModel(source) {
        this.priceMainClass = source.priceMainClass;
        this.period = source.period;
        this.statusClass = source.statusClass;
        this.rightDashCss = source.rightDashCss;
    }
    return PeriodViewDataModel;
}());
exports.PeriodViewDataModel = PeriodViewDataModel;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(106));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  defines SPPurchase.
 *
 * @typedef
 * @type {Object}
 * @property {purchaseId} Unique identifier
 * @property {name} Name of the event
 * @property {customerId} ID of the customer
 * @property {purchaseDate} Date when the purchase was placed
 * @property {currencyCode} Code of the currecny($,)
 * @property {currentBalance} currentBalance of the customer
 * @property {oddsStyleId} ID of the Odds Style
 * @property {purchaseStatus} Status of the purchase Won/Lost
 * @property {totalGain} Gain of the purchase
 * @property {totalStake} All the stakes for the purchase
 * @property {selections} All selections for the purchase
 * @property {bets} All bets for the purchase
 */
var SPPurchase = /** @class */ (function () {
    function SPPurchase(source) {
        this.purchaseId = source.purchaseId;
        this.purchaseDate = source.purchaseDate;
        this.customerId = source.customerId;
        this.currencyCode = source.currencyCode;
        this.currentBalance = source.currentBalance;
        this.oddsStyleId = source.oddsStyleId;
        this.purchaseStatus = source.purchaseStatus;
        this.totalGain = source.totalGain;
        this.totalStake = source.totalStake;
        this.bets = source.bets;
        this.selections = source.selections;
    }
    return SPPurchase;
}());
exports.SPPurchase = SPPurchase;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(108));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * SPSelection defines SP Selection for Open/BettingHistory purchase.
 *
 * @typedef SPSelection
 * @type {Object}
 * @property {id} Unique Id in the selection
 * @property {lineId} Unique identifier
 * @property {lineGroupId} Unique identifier of the group of the linq
 * @property {rowTypeId} type of row
 * @property {isOption} boolean is Optional
 * @property {isRegular} Is the lin e regular selection
 * @property {eventId} EventId of the current selection
 * @property {odds} Odds of the current Selection
 * @property {orgOdds} Original odds of the current selection
 * @property {clientOdds} Odds in the client OddsStyle
 * @property {branchId} brachId for the event
 * @property {leagueId} Id of the league
 * @property {masterLeagueId} masterLeagueId of the league
 * @property {splitTypeId} SplitTypeId of the selection
 * @property {eventTypeId} eventTypeId of the market
 * @property {eventGroupId} eventGroupId of the market
 * @property {isLive} was the selection placed live
 * @property {qPar1} qaParameter1 used for additional information
 * @property {qPar2} qaParameter2 used for additional information
 * @property {orderId} orderId used for sorting
 * @property {branchName} branchName Name of the branch
 * @property {eventName} name of the Event
 * @property {eventTypeName} name of the event/market type
 * @property {eventDate} date of the market/event
 * @property {leagueName} Name of the league
 * @property
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SPSelection = /** @class */ (function () {
    function SPSelection(source) {
        this.id = source.id;
        this.selectionId = source.selectionId;
        this.lineId = source.lineId;
        this.branchId = source.branchId;
        this.leagueName = source.leagueName;
        this.leagueId = source.leagueId;
        this.statusId = source.statusId;
        this.eventDate = source.eventDate;
        this.rowTypeId = source.rowTypeId;
        this.isOption = source.isOption;
        this.isRegular = source.isRegular;
        this.eventId = source.eventId;
        this.odds = source.odds;
        this.orgOdds = source.orgOdds;
        this.clientOdds = source.clientOdds;
        this.points = source.points;
        this.branchId = source.branchId;
        this.leagueId = source.leagueId;
        this.masterLeagueId = source.masterLeagueId;
        this.eventTypeId = source.eventTypeId;
        this.eventGroupId = source.eventGroupId;
        this.isLive = source.isLive;
        this.qPar1 = source.qPar1;
        this.qPar2 = source.qPar2;
        this.orderId = source.orderId;
        this.branchName = source.branchName;
        this.leagueName = source.leagueName;
        this.eventName = source.eventName;
        this.eventTypeName = source.eventTypeName;
        this.result = source.result;
    }
    return SPSelection;
}());
exports.SPSelection = SPSelection;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(110));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * SPOpenBet defines SP bet for Open bets  purchase.
 *
 * @typedef SPOpenBet
 * @type {Object}
 * @property {betId} Unique Id in the bet
 * @property {statusId} Determines is the bet open/won/lost etc.
 * @property {generatedId} Unique id of the bet in the purchase (1,2 etc. )
 * @property {currentBalance} current return of the bet
 * @property {deadHeatDeposit} Was there a dead heat applied to the deposit and how much
 * @property {commission} commission of the bet
 * @property {profitLoss} profitLoss of the bet
 * @property {percentDeduction} This is used for HR for withdrawn horses. You might get  lower odds.
 * @property {purchase} to which purchase this bet belongs
 * @property {mapping} Array of mapping needed for some bet types
 * @property {clientOdds} Odds in the client OddsStyle
 * @property {numberOfBets} Number of bets
 * @property {betSubType} Used in cast bettypes and other to determine the sub type of the bet (combination/straight forecast etc.)
 * @property {betTypeId} Used to determine type of bet (combo, single, teaser etc.)
 * @property {comboSize} determines the size of the combo
 * @property {betName} Name of the bet
 * @property {relatedToId} Used to show related free bet or EW bet if there is one
 * @property {deposit} Deposit of the bet
 * @property {gain} Gain of the bet
 * @property {odds} Odds of the bet
 * @property {dividend} fractional odds divident
 * @property {divisor} fractional odds divisor
 */
var SPOpenBet = /** @class */ (function () {
    function SPOpenBet(source) {
        this.betId = source.betId;
        this.generatedId = source.generatedId;
        this.statusId = source.statusId;
        this.currentBalance = source.currentBalance;
        this.deadHeatDeposit = source.deadHeatDeposit;
        this.commission = source.commission;
        this.profitLoss = source.profitLoss;
        this.percentDeduction = source.percentDeduction;
        this.purchase = source.purchase;
        this.mapping = source.mapping;
        this.clientOdds = source.clientOdds;
        this.numberOfBets = source.numberOfBets;
        this.betSubType = source.betSubType;
        this.betTypeId = source.betTypeId;
        this.comboSize = source.comboSize;
        this.betName = source.betName;
        this.relatedToId = source.relatedToId;
        this.deposit = source.deposit;
        this.gain = source.gain;
        this.odds = source.odds;
        this.dividend = source.dividend;
        this.divisor = source.divisor;
    }
    return SPOpenBet;
}());
exports.SPOpenBet = SPOpenBet;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(112));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
* MasterEventIncident defines model for in game incident object information
*
* @typedef MasterEventIncident
* @type {Object}
* @property {incidentID} IncidentID identifier of the incident
* @property {masterEventID} MasterEventID identifier of the master event where the incident accured
* @property {incitentTimeMs} IncidentTimeInMs from the start of the game
* @property {incidentTypeID} IncidentTypeId for the type of the incident
* @property {incidentStatusID} IncidentStatusID of the accured incident
*/
Object.defineProperty(exports, "__esModule", { value: true });
var MasterEventIncident = /** @class */ (function () {
    function MasterEventIncident(source) {
        this.incidentID = source.incidentID;
        this.masterEventID = source.masterEventID;
        this.incitentTimeMs = source.incitentTimeMs;
        this.incidentTypeID = source.incidentTypeID;
        this.incidentStatusID = source.incidentStatusID;
    }
    return MasterEventIncident;
}());
exports.MasterEventIncident = MasterEventIncident;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(114));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * PeriodFrame defines the startind and ending time points of a winning period.
 *
 * @typedef PeriodFrame
 * @type {Object}
 * @property {startTime} StartTime the starting time point
 * @property {endTime} EndTime the ending time point
 * @property {isTimeInSec} IsTimeInSec if the time is displayed in sec
 */
Object.defineProperty(exports, "__esModule", { value: true });
var PeriodFrame = /** @class */ (function () {
    function PeriodFrame(source) {
        this.startTime = source.startTime;
        this.endTime = source.endTime;
        this.isTimeInSec = source.isTimeInSec;
    }
    return PeriodFrame;
}());
exports.PeriodFrame = PeriodFrame;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(116));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * PlayByPlayIncident represents the incident recieved from PlayByPlay handler
 *
 * @prop {teamStatusID} number defines the ID of the team which recieved the incident
 * @prop {eventStatusID} number defines the ID of the incident (goal, penalty, free kick, etc.)
 * @prop {masterEventID} number it's the ID of the master(main) event
 */
var PlayByPlayIncident = /** @class */ (function () {
    function PlayByPlayIncident(source) {
        this.teamStatusID = source.teamStatusID;
        this.eventStatusID = source.eventStatusID;
        this.masterEventID = source.masterEventID;
    }
    return PlayByPlayIncident;
}());
exports.PlayByPlayIncident = PlayByPlayIncident;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(118));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var sb_resp_lib_1 = __webpack_require__(2);
var mobx_1 = __webpack_require__(1);
var QAEventInfoExt = /** @class */ (function (_super) {
    __extends(QAEventInfoExt, _super);
    function QAEventInfoExt(source) {
        var _this = _super.call(this, source) || this;
        _this.spLines = [];
        return _this;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], QAEventInfoExt.prototype, "spLines", void 0);
    return QAEventInfoExt;
}(sb_resp_lib_1.QAEventInfo));
exports.QAEventInfoExt = QAEventInfoExt;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(120));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
* PulseBetProgressData defines the data for the progress bar animation
*
* @typedef PulseBetProgressData
* @type {type}
* @property {periods} periods Collection with the periods in the bet
* @property {startTime} startTime Indicates what is the beggining point of the bet
* @property {endTime} endTime Indicates what is the ending point of the bet
* @property {expiredBetProgressInMilliseconds} expiredBetProgressInMilliseconds Indicates the already passed progress in the bet
*/
var PulseBetProgressData = /** @class */ (function () {
    function PulseBetProgressData(source) {
        this.periods = source.periods;
        this.startTime = source.startTime;
        this.endTime = source.endTime;
        this.expiredBetProgressInMilliseconds = source.expiredBetProgressInMilliseconds;
        this.id = source.id;
    }
    return PulseBetProgressData;
}());
exports.PulseBetProgressData = PulseBetProgressData;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(122));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
* PulseBetProgressPeriodData defines the data for the periods in progress bar animation
*
* @typedef PulseBetProgressPeriodData
* @type {type}
* @property {startTime} startTime The game time the period starts
* @property {duration} duration Duration of the period
*/
Object.defineProperty(exports, "__esModule", { value: true });
var PulseBetProgressPeriodData = /** @class */ (function () {
    function PulseBetProgressPeriodData(source) {
        this.startTime = source.startTime;
        this.duration = source.duration;
        this.id = source.id;
        this.periodNumber = source.periodNumber;
    }
    return PulseBetProgressPeriodData;
}());
exports.PulseBetProgressPeriodData = PulseBetProgressPeriodData;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(124));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__(1);
var ViewModel_1 = __webpack_require__(6);
var WinningDataInner = /** @class */ (function () {
    function WinningDataInner() {
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], WinningDataInner.prototype, "winningValue", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof ViewModel_1.ProgressStatus !== "undefined" && ViewModel_1.ProgressStatus) === "function" && _a || Object)
    ], WinningDataInner.prototype, "winningStatus", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], WinningDataInner.prototype, "statusClass", void 0);
    return WinningDataInner;
    var _a;
}());
exports.WinningDataInner = WinningDataInner;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(126));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var InstantCollapsible = /** @class */ (function (_super) {
    __extends(InstantCollapsible, _super);
    function InstantCollapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function (e) {
            _this.setState(function (prevState) { return ({ collapsed: !prevState.collapsed }); });
        };
        _this.state = {
            collapsed: _this.props.initiallyExpanded
        };
        return _this;
    }
    InstantCollapsible.prototype.render = function () {
        return (React.createElement("div", { className: "rj-instant-collapsible" },
            React.createElement("div", { className: "rj-instant-collapsible__trigger", onClick: this.toggle }, this.props.trigger),
            this.state.collapsed && this.props.content));
    };
    return InstantCollapsible;
}(React.Component));
exports.InstantCollapsible = InstantCollapsible;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// sb-responsive-pulse-bet-blocks.js